<!--
 * @Author: guoyu
 * @Date: 2020-05-08 14:54:51
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-04 17:48:43
 * @Description: 支付的金额信息（ios与android会有所不同）
 -->
<template>
  <div class="pay-info">
    <div class="price">
      <span>{{$t('upgrade_page_views_order_components_pay_info_341')}}（{{ unitMode.salesUnit | salesUnitTranslate }} * {{ count }}）<span v-if="sendCount" class="send-num">{{$t('upgrade_page_views_order_components_pay_info_342')}}{{ sendCount }}</span></span>
      <span class="icon-container">{{ allPrice }}{{$t('upgrade_page_views_home_suggest_item_4')}}</span>
    </div>
    <div class="price" v-if="couponInfo.couponName">
      <span>
        <!-- <i class="text-icon">券</i> -->
        {{ couponInfo.couponName }}
      </span>
      <span class="coupon-price">{{$t('upgrade_page_views_order_components_pay_info_344', [ couponInfo.coupons ])}}</span>
    </div>
    <div
      v-if="showNewerPrice"
      class="price"
    >
      <span><!-- <i class="text-icon">新</i> -->
        {{$t('upgrade_page_views_order_components_pay_info_345')}}</span>
      <span class="coupon-price">{{$t('upgrade_page_views_order_components_pay_info_344', [ newerCoupns ])}}</span>
    </div>
    <div class="price" v-if="showFirstCoupon">
      <span>{{$t('upgrade_page_views_player_list_index_196')}}</span>
      <span class="coupon-price">{{$t('upgrade_page_views_order_components_pay_info_344', [ firstCoupons ])}}</span>
    </div>
    <div class="price pay-price">
      <span class="price-text">{{$t('upgrade_page_views_order_components_pay_info_346')}}</span>
      <span class="price-num  icon-container">{{$t('upgrade_page_views_order_components_pay_info_343', [ price ])}}</span>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
export default {
  name: 'PayInfo',
  props: {
    price: { type: Number, default: 0 }, // 实付
    allPrice: { type: Number, default: 0 }, // 總價
    isPc: { type: Boolean, default: true},
    isFromNew: { type: Boolean, default: false },
    skillInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    couponInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    sendCount: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 1,
    },
    unitMode: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    payText() {
      return this.isIos ? i18n.t('upgrade_page_views_order_components_pay_info_348') : i18n.t('upgrade_page_views_order_components_pay_info_347');
    },
    newerCoupns() {
      if(!this.skillInfo.selfSpreadPrice && this.skillInfo.selfSpreadPrice !== 0) return 0
      return this.skillInfo.salesPrice - this.skillInfo.selfSpreadPrice || 0;
    },
    showNewerPrice() {
      return (
        this.isFromNew &&
        this.newerCoupns &&
        this.skillInfo.redBagFreeFlag &&
        !this.unitMode.id &&
        !this.$route.query.quickMatchUuid
      );
    },
     // 首單優惠
    firstCoupons() {
      return this.skillInfo.firstOrderDiscount
    },
    showFirstCoupon() {
      return this.skillInfo.firstOrderDiscount && this.skillInfo.firstOrderPrivilege && !this.$route.query.quickMatchUuid
    }
  }
};
</script>
<style lang="scss" scoped>
.pay-info {
  padding: 25px 18px 50px;
  background: #f9f9f9;
  font-size: 14px;
}
.price {
  display: flex;
  margin-bottom: 15px;
  justify-content: space-between;
  line-height: 1;
}
.price-text {
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
}
.price-num {
  font-weight: 500;
  font-size: 20px;
}
.text-icon {
  display: inline-block;
  height: 16px;
  width: 16px;
  padding: 2px;
  margin-right: 4px;
  border-radius: 3px;
  font-size: 12px;
  line-height: 1;
  font-style: normal;
  color: #ffffff;
  background: #FF8973;
}
.coupon-price {
  color: #FA006E;
}
.pay-price {
  padding-top: 12px;
  border-top: 1px solid #E3E3E3;
  margin-top: 12px;
}
.send-num {
  color: #3CAC2D;
}
@media screen and (min-width: 600px) {
  .pay-info {
    padding: 0;
    background: none;
    font-size: 14px;
    color: #666666;
  }
  .price-num {
    font-weight: 500;
    font-size: 20px;
  }
  .icon-container {
    display: flex;
    align-items: center;
  }
}
</style>
